import { Ajax } from "../utils/base";
import IP from "../config/config"
// const DC = process.env.VUE_APP_DC;
// const NEWS = process.env.VUE_APP_NEWS;
// 模型聚合页入口列表
export function getDataModelIndex (params) {
    const url = IP.dcApis() + '/dataModel/index';
    return Ajax(url, params, "GET")
}
export function getDataModelBanner (params) {
    const url = IP.apis() + '/common/banner';
    return Ajax(url, params, "GET")
}
export function getModelCorpus (params) {
    const url = IP.dcApis() + '/dataModel/modelMergeList';
    return Ajax(url, params, "GET")
}
export function getHotListRank (params) {
    const url = IP.mApis() + '/news/expert/hot-list/rank';
    return Ajax(url, params, "GET")
}
